import { useEffect } from 'react';
import useClinicProductsForm from '../../../ClinicProduct/hooks/useClinicProductForm';
import { ClinicProduct } from '../../../../apis/clinic-products/types';

const usePutClinicProductsInForm = (
  productsForm: ReturnType<typeof useClinicProductsForm>,
  clinicProducts: ClinicProduct[]
) => {
  useEffect(() => {
    const productsInForm = Object.values(productsForm.getValues());

    if (!productsInForm.length && clinicProducts.length) {
      productsForm.reset(clinicProducts);
    }
  }, [productsForm, clinicProducts]);
};

export default usePutClinicProductsInForm;
